export default __webpack_public_path__ + "images/aerial-0035080fe216e1fd0a8edc4d3a348b53.png";